/**
 * Created by razial on 16.02.2026
 */

const EditorClientStatus = cc.Node.extend({
    ctor: function (editorClient) {
        this._super();

        this.setAnchorPoint(0.5, 0);

        this.editorClient = editorClient;

        this.bg = cleverapps.UI.createScale9Sprite(bundles.git.frames.button, cleverapps.UI.Scale9Rect.TwoPixelXY);
        this.addChild(this.bg);

        this.updateState();

        editorClient.on("updateEditors", this.updateState.bind(this), this);
        editorClient.on("updateState", this.updateState.bind(this), this);
        editorClient.on("updateCommands", this.updateControls.bind(this), this);

        cleverapps.git.on("changed", this.updateControls.bind(this), this);
    },

    updateState: function () {
        const styles = cleverapps.styles.EditorClientStatus;

        if (this.layout) {
            this.layout.removeFromParent();
            this.layout = undefined;
        }

        const items = [cleverapps.UI.generateOnlyText("Editors:", cleverapps.styles.FONTS.EDITOR_CLIENT_STATUS_TITLE)];

        if (this.editorClient.getConnectionState() === EditorClient.CONNECTION_DISCONNECTED) {
            items.push(cleverapps.UI.generateOnlyText("connecting...", cleverapps.styles.FONTS.EDITOR_CLIENT_STATUS_TEXT));
        } else if (this.editorClient.getEditors()) {
            const currentUserId = this.editorClient.getUserId();
            this.editorClient.getEditors().forEach((editor) => {
                const text = editor.userId;
                const font = editor.userId === currentUserId
                    ? cleverapps.styles.FONTS.EDITOR_CLIENT_STATUS_TEXT_CURRENT
                    : cleverapps.styles.FONTS.EDITOR_CLIENT_STATUS_TEXT;

                items.push(cleverapps.UI.generateOnlyText(text, font));
            });
        }

        this.layout = new cleverapps.Layout(items, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
        this.bg.addChild(this.layout);

        this.bg.setContentSize(Math.min(styles.maxWidth, this.layout.width + styles.padding * 4), this.layout.height + styles.padding * 2);
        this.bg.setPosition(this.bg.width / 2, this.bg.height / 2);
        this.layout.setPosition(this.bg.width / 2, this.bg.height / 2);
        this.setContentSize(this.bg.getContentSize());

        this.createControls();

        this.doAlignment();
    },

    createControls: function () {
        if (this.controls) {
            this.controls.removeFromParent();
        }

        const styles = cleverapps.styles.EditorClientStatus.controls;

        this.undoButton = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.git,
            text: "\u21A9",
            width: styles.buttonSize,
            height: styles.buttonSize,
            hint: "Undo",
            onDisableHint: "Undo",
            onClicked: () => this.editorClient.undoCommand()
        });

        this.redoButton = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.git,
            text: "\u21AA",
            width: styles.buttonSize,
            height: styles.buttonSize,
            hint: "Redo",
            onDisableHint: "Redo",
            onClicked: () => this.editorClient.redoCommand()
        });

        this.undoAllButton = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.git,
            text: "\u21A9\u21A9",
            width: styles.buttonSize,
            height: styles.buttonSize,
            hint: "Undo all",
            onDisableHint: "Undo all",
            onClicked: () => {
                while (this.editorClient.undoCommand()) {
                    // do nothing
                }
            }
        });

        this.pushButton = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.git,
            text: "\u2191",
            width: styles.buttonSize,
            height: styles.buttonSize,
            hint: "Push",
            onDisableHint: "Push",
            onClicked: () => {
                cleverapps.git.displayWindow("push");
            }
        });

        this.pushButton.loading = new cc.Sprite(bundles.git.frames.loading);
        this.pushButton.loading.setAlignment(this.pushButton.content.x, this.pushButton.content.y);
        this.pushButton.addChild(this.pushButton.loading);

        cleverapps.UI.fitToBox(this.pushButton.loading, {
            width: styles.buttonSize - styles.buttonPadding * 2,
            height: styles.buttonSize - styles.buttonPadding * 2
        });

        this.nukeButton = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.git,
            text: "\u2620",
            width: styles.buttonSize,
            height: styles.buttonSize,
            hint: "Nuke all changes",
            onDisableHint: "Nuke all changes",
            onClicked: () => {
                if (window.confirm("DANGER! This will permanently DESTROY all your local changes AND wipe the entire command history on the server for every editor. This cannot be undone. Are you absolutely sure?")) {
                    this.editorClient.resetAllChanges();
                }
            }
        });

        this.nukeButton.passBlocked = true;

        this.controls = new cleverapps.Layout([this.undoButton, this.redoButton, this.undoAllButton, this.pushButton, this.nukeButton], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });

        this.controls.setPosition(this.bg.width / 2, this.bg.height + this.controls.height / 2 + styles.dy);
        this.addChild(this.controls);

        this.updateControls();
    },

    updateControls: function () {
        const hasUndo = this.editorClient.undoStack.length > 0;
        const hasRedo = this.editorClient.redoStack.length > 0;

        hasUndo ? this.undoButton.enable() : this.undoButton.disable();
        hasRedo ? this.redoButton.enable() : this.redoButton.disable();
        hasUndo ? this.undoAllButton.enable() : this.undoAllButton.disable();

        const status = cleverapps.git.getStatus();

        this.pushButton.disable();
        this.pushButton.content.setVisible(true);
        this.pushButton.loading.setVisible(false);
        this.pushButton.loading.stopAllActions();

        if (status === GitManager.STATUS_ERROR) {
            // do nothing
        } else if (status === GitManager.STATUS_PROCESSING) {
            this.pushButton.disable();
            this.pushButton.content.setVisible(false);
            this.pushButton.loading.setVisible(true);
            this.pushButton.loading.runAction(new cc.RepeatForever(new cc.RotateBy(5, 360)));
        } else if (cleverapps.git.listLocalChanges().length > 0) {
            this.pushButton.enable();
        } else {
            // do nothing
        }
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    EDITOR_CLIENT_STATUS_TITLE: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        font: bundles.chat.urls.strict_font_ttf
    },
    EDITOR_CLIENT_STATUS_TEXT: {
        size: 36,
        color: cleverapps.styles.COLORS.WHITE,
        font: bundles.chat.urls.strict_font_ttf
    },
    EDITOR_CLIENT_STATUS_TEXT_CURRENT: {
        size: 36,
        color: cleverapps.styles.COLORS.COLOR_DARK_YELLOW,
        font: bundles.chat.urls.strict_font_ttf
    }
});

cleverapps.styles.EditorClientStatus = {
    padding: 5,
    margin: 2,
    maxWidth: 240,

    controls: {
        buttonSize: 50,
        buttonPadding: 10,
        margin: 5,
        dy: 10
    }
};
